import { SurveyName } from '~/lib/constants/survey/SurveyName';

export const generalClinicianSurveyNames: SurveyName[] = [
  SurveyName.AIMS,
  SurveyName.AUDIT,
  SurveyName.C_SSRS_LIFETIME,
  SurveyName.C_SSRS_RECENT_SCREENER,
  SurveyName.C_SSRS_SINCE_LAST_CONTACT,
  SurveyName.C_SSRS_SLC_SCREENER,
  SurveyName.DISCHARGE_SUMMARY,
  SurveyName.DUDIT,
  SurveyName.EARLY_RESPONSE_CHECK_IN,
  SurveyName.LETHAL_MEANS,
  SurveyName.MP_INTAKE_ASSESSMENT,
  SurveyName.NIAAA_BSTAD,
  SurveyName.POP,
  SurveyName.SAFETY_PLAN,
  SurveyName.TREATMENT_UPDATE,
];

export const generalCarerSurveyNames: SurveyName[] = [
  SurveyName.PHQ8,
  SurveyName.PHQ9,
  SurveyName.GAD7,
  SurveyName.BAS,
  SurveyName.CET,
  SurveyName.EDE_Q,
  SurveyName.PSEA,
  SurveyName.NPS,
  SurveyName.ADMISSIONS_INTAKE,
  SurveyName.ADMISSIONS_NPS,
  SurveyName.PATIENT_EXPERIENCE,
];

export const diagnosisClinicianSurveyNames: SurveyName[] = []; // Will be added in future

export const diagnosisCarerSurveyNames: SurveyName[] = [
  SurveyName.ARFID,
  SurveyName.FNS,
  SurveyName.NIAS,
  SurveyName.NON_ARFID,
  SurveyName.PARDI_ARQ_PARENT,
  SurveyName.PARDI_ARQ_SELF,
  SurveyName.PCL5,
];
